/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';

//----------------------------------------------------------------------//
// MATERIAL UI                                                          //
//----------------------------------------------------------------------//

import Button from '@material-ui/core/Button';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

import { translate } from 'react-i18next';

import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore';

import styles from '../../../../ActionDrawer.module.scss';

type TypeProps = {
  t: TranslatorProps,
  actionDrawerStore: TypeActionDrawerStore,
  response: Object,
};

@translate()
@inject('actionDrawerStore')
@observer
export default class RemoveAssetFromProjectSuccess extends React.Component<*> {
  render(): React.Node {
    const { t, actionDrawerStore, response }: TypeProps = this.props;

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <div className={styles['success-details']}>
            <h3>{t('general:assets.removed_from_project')}</h3>
            <p>{t('general:assets.messages.removed_from_project')}</p>
            <ul>
              <li>
                <b>{t('general:asset')}:</b>
              </li>
              <li>{`${response.asset_number}, ${response.manufacturer}, ${response.model}`}</li>
            </ul>
            <ul>
              <li>
                <b>{t('general:projects.removed_from')}:</b>
              </li>
              <li>{response.project_name}</li>
              {/*
                                response.projects.map((item: Object, index: number) => (
                                    <li key={index.toString()}>
                                        {`${ item.code } - ${ item.name }`}
                                    </li>
                                ))
                                */}
            </ul>
          </div>
        </div>
        <div className={styles['action-drawer-actions']}>
          <Button
            color="primary"
            variant="contained"
            onClick={() => actionDrawerStore.closeActionDrawer()}
          >
            {t('general:actions.close')}
          </Button>
        </div>
      </React.Fragment>
    );
  }
}
